<template>
  <router-view />
  <!-- <router-view :key="$route.fullPath" /> -->

  <websocket />
  <websocketAI />
</template>

<script>
import websocket from "@/views/websocket/index.vue";
import websocketAI from "@/views/websocket/index_ai.vue";

export default {
  components: {
    websocket,
    websocketAI,
  },
  mounted() {
    this.pvMaidian(); // pv 埋点

    window.addEventListener("storage", (event) => {
      if (event.key === "yx_isLogin") {
        // console.log("yx_isLogin:", event.newValue);

        // 更新页面状态
        location.reload();
      }
    });
  },
  methods: {
    // pv 埋点
    pvMaidian() {
      this.COMMON.zhuGeIdentify(); // 诸葛 实名

      this.COMMON.zhuGeMaidian("pv"); // 诸葛 埋点
      this.COMMON.zhuGeMaidian("in_web"); // 诸葛 埋点
    },
  },
};
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
}

body {
  letter-spacing: 1px;
}

.loading-message .el-message__icon {
  animation: rotating 2s linear infinite;
}
@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>

